/**
 * Graphql mutation to create/update Expense Inventory case usage line items.
 * @module src/graphql/mutations/createUpdateExpenseLineItems
 */
import gql from 'graphql-tag';

const CREATE_UPDATE_EXPENSE_LINE_ITEMS = gql`
  mutation createUpdateExpenseLineItems(
    $caseId: String
    $caseExternalId: String
    $formType: String!
    $salesRepId: String
    $system: String
    $version: String
    $lineItems: [ExpenseInventoryLineItems]
  ) {
    createUpdateExpenseLineItems(
      caseId: $caseId
      caseExternalId: $caseExternalId
      formType: $formType
      salesRepId: $salesRepId
      system: $system
      version: $version
      lineItems: $lineItems
    ) {
      message
      externalId
      sfid
      isMaxQuantityExceeded
    }
  }
`;

export default CREATE_UPDATE_EXPENSE_LINE_ITEMS;
